import React from "react";
import { FormattedMessage } from "react-intl";
import { Box, Flex, Heading } from "@chakra-ui/react";
import { BidirectionalMoneyIcon } from "components/Icons";

const NoPendingPayouts = () => {
  return (
    <Box mt="40px" mb="100px" textAlign="center">
      <Flex mb="20px" justifyContent="center">
        <BidirectionalMoneyIcon color="integrator.100" />
      </Flex>
      <Heading lineHeight="28px" mb="14px">
        <FormattedMessage defaultMessage="No Pending Payouts" description="Section Header" />
      </Heading>
      <Box lineHeight="24px">
        <FormattedMessage
          defaultMessage="This is where you'll see any pending payouts"
          description="Informative message"
        />
      </Box>
    </Box>
  );
};

export default NoPendingPayouts;
